export const getTherapyStatusLabel = (status) => {
  const map = {
    current: 'Aktuelna',
    past: 'Prosla',
    missed: 'Propustena',
  };

  return map[status] || status || '-';
};

export const getTherapyTypeLabel = (therapy) =>
  therapy?.isAcute ? 'Akutna terapija' : 'Hronicna terapija';

export const getTherapyDisplayName = (therapy) => {
  const name = therapy?.name?.trim() || '-';
  return therapy?.isAcute ? `${name} (Akutna)` : name;
};

export const getTherapyReservationStatusLabel = (status) => {
  const map = {
    pending: 'Na cekanju',
    applied: 'Primenjena',
  };

  return map[status] || status || '-';
};

export const getTherapyPatientName = (therapy) => {
  const userName = therapy?.userName?.trim();
  const fullName =
    `${therapy?.firstName || ''} ${therapy?.lastName || ''}`.trim();

  return (
    userName ||
    fullName ||
    therapy?.userFullName ||
    therapy?.userEmail ||
    therapy?.email ||
    therapy?.userPhone ||
    therapy?.phone ||
    '-'
  );
};
